import { render, staticRenderFns } from "./fixedAssets.vue?vue&type=template&id=6ea021ba&scoped=true&"
import script from "./fixedAssets.vue?vue&type=script&lang=js&"
export * from "./fixedAssets.vue?vue&type=script&lang=js&"
import style0 from "./fixedAssets.vue?vue&type=style&index=0&id=6ea021ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea021ba",
  null
  
)

export default component.exports